import { MentionNodeDataProvider } from '@atlaskit/editor-plugin-mentions/mention-node-data-provider';

import { expVal } from '@confluence/feature-experiments';

type MentionAvatarData = {
	avatarUrl: string;
	isAvatarImagePreShaped: boolean;
};

type MentionNodeIdentifier = {
	id: string;
	userType?: string;
};

const resolveMentionNodeData = ({
	id: accountId,
	userType,
}: MentionNodeIdentifier): MentionAvatarData => ({
	avatarUrl: `/wiki/aa-avatar/${encodeURIComponent(accountId)}`,
	isAvatarImagePreShaped:
		userType !== 'APP' && userType !== 'AGENT'
			? true
			: !expVal('platform_editor_drop3_hexagon_agent_avatar', 'isEnabled', false),
});

/** Creates a page-scoped provider backed by Confluence's deterministic avatar route. */
export const createMentionNodeDataProvider = (): MentionNodeDataProvider =>
	new MentionNodeDataProvider(() => Promise.resolve({}), resolveMentionNodeData);
